<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
@if (isVisible()) {
  <div
    class="fixed inset-0 z-40 flex items-center justify-center overflow-y-auto bg-black/20 backdrop-blur-xs p-6"
  >
    <!-- Modal contenedor interno -->
    <div [style.z-index]="zIndex()" class="w-full">
      <!-- Contenido del popup -->
      <div
        [ngClass]="sizeClasses()"
        class="relative rounded-[32px] flex flex-col bg-white text-left shadow-xl transform transition-all w-full overflow-hidden max-h-[calc(100vh-16px)] sm:max-h-[calc(95vh-32px)] mx-auto"
      >
        <!-- Cabecera -->
        <div
          class="relative flex items-center justify-between border-b border-none bg-white px-4 pt-4 flex-none"
        >
          <h3 class="text-[20px] text-basic font-bold pr-5">{{ title() | translate }}</h3>
          <button
            type="button"
            class="text-error text-[24px] cursor-pointer"
            (click)="onCancelled()"
            aria-label="Close"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="px-4">
          <hr class="mt-2 mb-[16px] text-caption_light flex-none" />
        </div>

        <!-- Cuerpo scrollable -->
        <div class="flex-1 overflow-y-auto p-4 min-h-0">
          <ng-content></ng-content>
        </div>
        @if (showCancel() || showConfirm()) {
          <!-- Pie de página fijo -->
          <div
            class="flex flex-col-reverse sm:flex-row flex-none w-full pt-4 pb-6 px-4 gap-2 sm:gap-4 rounded-b-lg"
          >
            <!-- Cancel: en móvil abajo -->
            @if (showCancel()) {
              <div class="flex-1">
                <lib-custom-button
                  [disabled]="loading()"
                  label="{{ cancelText() || ('SHARED.POPUP.CANCEL_BUTTON' | translate) }}"
                  variant="cancel"
                  [fullWidth]="true"
                  (clicked)="onCancelled()"
                ></lib-custom-button>
              </div>
            }

            <!-- Confirm: en móvil arriba -->
            @if (showConfirm()) {
              <div class="flex-1">
                <lib-custom-button
                  [fullWidth]="true"
                  [loading]="loading()"
                  [disabled]="loading()"
                  label="{{ confirmText() || ('SHARED.POPUP.ACCEPT_BUTTON' | translate) }}"
                  variant="confirm"
                  (clicked)="onConfirm()"
                ></lib-custom-button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
